module.exports = __webpack_public_path__ + "img/_add.5978f2de.svg";